import React from "react";
import { Metric } from "../shared/Metric";
import { useAppContext } from "../../AppContext";

/* -----------------------------------------------------------------------------
 * AnalyticsPanel — admin "DASHBOARD" tab. Live KPIs (revenue, pending /
 * processing / completed orders, USD→Bs rate). Pure render — pulls
 * everything it needs from AppContext.
 * --------------------------------------------------------------------------- */
export function AnalyticsPanel() {
  const {
    totalRevenueUsd, pendingOrdersCount, processingOrdersCount,
    completedOrdersCount, exchangeRate, rateReady, usdToBs, formatBs,
  } = useAppContext();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-testid="admin-dashboard-view">
      <Metric label="Ingresos" value={formatBs(usdToBs(totalRevenueUsd))} color="text-white" />
      <Metric label="Pendientes" value={pendingOrdersCount} color="text-yellow-400" />
      <Metric label="En Proceso" value={processingOrdersCount} color="text-cyan-400" />
      <Metric label="Completados" value={completedOrdersCount} color="text-green-400" />
      <Metric label="Tasa USD/Bs" value={rateReady ? `${exchangeRate.toFixed(2)}` : "…"} color="text-purple-400" />
    </div>
  );
}
